import React, { useState, useEffect, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import searchIcon from "../../assets/image/search.svg";
import nonAvatart from "../../assets/image/non-avatar.png";
import { getSearchResults } from "../../actions/searchActions";

const Search = ({ history, location }) => {
    const dispatch = useDispatch();
    const { search_result: searchResult, loading: searchLoading } = useSelector(state => state.search);

    const [searchValue, setSearchValue] = useState("");
    const [searchError, setSearchError] = useState("");
    const [liveSearch, setLiveSearch] = useState(false);
    const cancelTokenRef = useRef(null);

    // Initial search value from URL
    useEffect(() => {
        const pathSearchValue = location.pathname.split("/search/")[1];
        if (pathSearchValue) {
            setSearchValue(decodeURIComponent(pathSearchValue));
        }
    }, [location.pathname]);

    const searchFunc = useCallback((value) => {
        if (value.replace(/\s/g, "").length > 0) {
            try {
                if (cancelTokenRef.current) {
                    cancelTokenRef.current.cancel('cancel');
                }
                cancelTokenRef.current = axios.CancelToken.source();
                dispatch(getSearchResults(value, cancelTokenRef.current)).then(() => {
                    setSearchError("");
                    setLiveSearch(true);
                });
            } catch (error) {
                console.log(error);
            }
        } else {
            setSearchError("");
            setLiveSearch(false);
        }
    }, [dispatch]);

    useEffect(() => {
        if (searchValue) {
            searchFunc(searchValue);
        } else {
            setLiveSearch(false);
        }
    }, [searchValue, searchFunc]);

    const changeSearchInput = (e) => {
        setSearchValue(e.target.value);
    };

    const inputEnter = (e) => {
        if (e.keyCode === 13) {
            applySearch();
        }
    };

    const searchFocus = () => {
        if (searchValue) {
            searchFunc(searchValue);
        }
    };

    const applySearch = () => {
        if (searchValue.replace(/\s/g, "").length > 0) {
            setLiveSearch(false);
            history.push(`/main/shop/search/${searchValue}`);
        } else {
            setLiveSearch(false);
            setSearchError("Поисковой запрос не может быть пустым или состоять только из пробелов");
            setTimeout(() => setSearchError(""), 3000);
        }
    };

    const goToProd = (slug) => {
        history.push(`/main/shop/product/${slug}`);
    };

    const goToCat = (relative_url) => {
        history.push(`/main/shop?cat=${relative_url}`);
    };

    return (
        <div className="search_wrapper">
            <span>
                <img src={searchIcon} alt="search" />
            </span>
            <input
                onChange={changeSearchInput}
                onKeyDown={inputEnter}
                onFocus={searchFocus}
                value={searchValue}
                type="text"
                placeholder="Поиск "
            />
            <span className={`error_text`}>{searchError}</span>
            {liveSearch && (
                <div className="search_backdrop" onClick={() => setLiveSearch(false)}>
                    <div className="search_info 1">
                        <div className="wrapper_scroll">
                            <div className="title_search">Товары</div>
                            <div className="product_search">
                                {searchResult && searchResult.products && searchResult.products.length > 0 ? (
                                    searchResult.products.map((el, idx) => (
                                        <div key={idx} onClick={() => goToProd(el.id)}>
                                            <div className="img">
                                                <img src={el.images[0] || nonAvatart} alt="product" />
                                            </div>
                                            <div className="prod_info">
                                                <div className="name">{el.name}</div>
                                                <div className="wrapper_info">
                                                    <div className="art">Арт. {el.article_number}</div>
                                                    {!!el.discount_price ? (
                                                        <div className="price stock">
                                                            {el.discount_price} грн{" "}
                                                            <p>{el.retail_price} грн</p>
                                                        </div>
                                                    ) : (
                                                        <div className="price">
                                                            {el.has_id_1c === false ? (
                                                                <div>{el.price} грн</div>
                                                            ) : (
                                                                <div>{el.retail_price} грн</div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <span className={`no_search_items`}>
                                        По Вашему запросу товаров не найдено
                                    </span>
                                )}
                            </div>

                            <div className="info">
                                <p>Категории</p>
                                {searchResult && searchResult.categories && searchResult.categories.length > 0 ? (
                                    searchResult.categories.map((el, idx) => (
                                        <span onClick={() => goToCat(el.id)} key={idx}>
                                            {el.name}
                                        </span>
                                    ))
                                ) : (
                                    <span className={`no_search_items`}>Категорий нет</span>
                                )}
                            </div>
                        </div>
                        <button onClick={applySearch} disabled={searchLoading}>
                            {searchLoading ? (
                                <CircularProgress color="inherit" size={24} />
                            ) : (
                                `Все результаты поиска (${searchResult ? searchResult.total_count : 0})`
                            )}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default withRouter(Search);
